module.exports = "https://cdn01.riselinkedu.com/assets/images/book@2x.8185cbd.png";